/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import rtkRequestStatusCodes from "../../lib/const/rtkRequestStatusCodes";
import Message from "../../components/Message/Message";
import {
  getAssignPermissionsRoute,
  getBlockPermissionsRoute,
  getPermissionsRoute,
} from "../../lib/routes/security";

const initialState = {
  permissions: [],
  permissionsLoading: rtkRequestStatusCodes.idle,
  permissionsAdding: rtkRequestStatusCodes.idle,
};

const fetchPermissions = createAsyncThunk("permissions/fetchAll", async () => {
  const response = axios.get(getPermissionsRoute());
  const { data } = await response;
  return data;
});

const assignPermissionsToUser = createAsyncThunk(
  "permissions/assignPermissions",
  async ({ userId, permissionsArr }) => {
    const response = axios.post(getAssignPermissionsRoute(userId, permissionsArr));
    const { data } = await response;
    return data;
  }
);

const blockPermissionsToUser = createAsyncThunk(
  "roles/blockRoles",
  async ({ userId, permissionsArr }) => {
    const response = axios.post(getBlockPermissionsRoute(userId, permissionsArr));
    const { data } = await response;
    return data;
  }
);

export const permissionsSlice = createSlice({
  name: "permissions",
  initialState,
  extraReducers: {
    [fetchPermissions.fulfilled]: (state, action) => {
      state.permissions = action.payload.content;
      state.permissionsLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchPermissions.pending]: (state) => {
      state.permissionsLoading = rtkRequestStatusCodes.pending;
    },
    [fetchPermissions.rejected]: (state, action) => {
      state.permissionsLoading = rtkRequestStatusCodes.rejected;
      Message(action.error.message);
    },
    [assignPermissionsToUser.fulfilled]: (state) => {
      state.permissionsAdding = rtkRequestStatusCodes.fulfilled;
    },
    [assignPermissionsToUser.pending]: (state) => {
      state.permissionsAdding = rtkRequestStatusCodes.pending;
    },
    [assignPermissionsToUser.rejected]: (state, action) => {
      state.permissionsAdding = rtkRequestStatusCodes.rejected;
      Message(action.error.message);
    },
    [blockPermissionsToUser.fulfilled]: (state) => {
      state.rolesBlocking = rtkRequestStatusCodes.fulfilled;
    },
    [blockPermissionsToUser.pending]: (state) => {
      state.rolesBlocking = rtkRequestStatusCodes.pending;
    },
    [blockPermissionsToUser.rejected]: (state, action) => {
      state.rolesBlocking = rtkRequestStatusCodes.rejected;
      Message(action.error.message);
    },
  },
});

const { reducer } = permissionsSlice;

export { fetchPermissions, assignPermissionsToUser, blockPermissionsToUser, reducer };
